// extracted by mini-css-extract-plugin
export default {"vesticoBanner":"Banner-module-vesticoBanner-Ex6s1","rtl":"Banner-module-rtl-Qh9_q"};